import { render, staticRenderFns } from "./Lange.vue?vue&type=template&id=7a94f4b2&scoped=true&"
import script from "./Lange.vue?vue&type=script&lang=js&"
export * from "./Lange.vue?vue&type=script&lang=js&"
import style0 from "./Lange.vue?vue&type=style&index=0&id=7a94f4b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a94f4b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
